import React from 'react';
import './ArtworkCard.css';

function ArtworkCard({ artwork, fadeOpacity = 1, generatedOpacity = 0, isFinal = false }) {
  return (
    <div className="artwork-card">
      {artwork.title && <h1 className="artwork-title">{artwork.title}</h1>}
      {artwork.autor && (<h2 className="artwork-author">({artwork.autor},&nbsp;
      {artwork.fecha})</h2>)}

      {/* Contenedor de la imagen con altura mínima */}
      
        {/* Imagen original */}
        {artwork.image && (
          <div style={{
            position: "relative",
            width: "100%",
            minHeight: "50vh", // Establecemos una altura mínima
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden"
          }}>
          <img
            src={artwork.image}
            alt={artwork.title}
            style={{
              width: "auto",
              height: "100%",
              maxHeight: "100%",
              objectFit: "contain", // Evita recortes
              opacity: isFinal ? fadeOpacity : 1,
              position: "absolute",
              transition: "opacity 2s ease-in-out",
              margin: "1rem"
            }}
          />
          </div>
        )}

        {/* Imagen generada (solo en la última ficha) */}
        {isFinal && artwork.generatedImage && (
          <div style={{
            position: "relative",
            width: "100%",
            minHeight: "50vh", // Establecemos una altura mínima
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden"
          }}>
          <img
            src={artwork.generatedImage}
            alt="Imagen generada"
            style={{
              width: "auto",
              height: "100%",
              maxHeight: "100%",
              objectFit: "contain", // Evita que se recorte la imagen
              opacity: generatedOpacity,
              position: "absolute",
              transition: "opacity 2s ease-in-out"
            }}
          />
          </div>
        )}

      {artwork.description && (
        <p className="description" dangerouslySetInnerHTML={{ __html: artwork.description }} />
      )}

      {/* Reproductor de audio si está disponible */}
      {artwork.audio && (
        <audio key={artwork.audio} controls>
          <source src={artwork.audio} type="audio/mp3" />
          Tu navegador no soporta el elemento de audio.
        </audio>
      )}
    </div>
  );
}

export default ArtworkCard;
